import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { ArrowRight, ShoppingBag, Building2, Image, LayoutDashboard } from "lucide-react";

const ICONS = [ShoppingBag, Building2, Image, LayoutDashboard];

const Work = () => {
  const { t } = useLanguage();
  const items = t.work.items;

  return (
    <section
      id="work"
      data-testid="work-section"
      className="py-24 sm:py-32 px-5 sm:px-8 bg-brand-surface/40"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mb-14 items-end">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-px bg-brand" />
              <span className="text-[11px] tracking-[0.25em] font-bold text-brand">
                {t.work.eyebrow}
              </span>
            </div>
          </div>
          <h2
            className="md:col-span-7 font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-brand-ink leading-tight"
            data-testid="work-title"
          >
            {t.work.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <a
                key={i}
                href="#contact"
                data-testid={`work-item-${i}`}
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="group relative block rounded-3xl bg-white border border-brand-line/70 hover:border-brand/40 hover:shadow-lg transition-all duration-500 hover:-translate-y-1 p-8 sm:p-10 overflow-hidden"
              >
                <div className="absolute -top-20 -right-20 w-60 h-60 bg-brand/5 rounded-full blur-3xl group-hover:bg-brand/10 transition" aria-hidden />

                <div className="relative">
                  <div className="flex items-start justify-between mb-8">
                    <div className="w-14 h-14 rounded-2xl bg-brand-surface flex items-center justify-center group-hover:bg-brand transition-colors duration-300">
                      <Icon
                        size={22}
                        strokeWidth={1.5}
                        className="text-brand group-hover:text-white transition-colors duration-300"
                      />
                    </div>
                    <span className="text-[10px] tracking-[0.3em] font-bold text-brand-muted">
                      {it.tag}
                    </span>
                  </div>

                  <h3 className="font-display text-2xl sm:text-3xl font-medium text-brand-ink tracking-tight mb-3">
                    {it.name}
                  </h3>
                  <p className="text-base text-brand-muted leading-relaxed mb-6 max-w-md">
                    {it.desc}
                  </p>

                  <div className="inline-flex items-center gap-2 text-sm font-semibold text-brand group-hover:gap-3 transition-all">
                    {t.work.viewAll}
                    <ArrowRight size={16} strokeWidth={2} />
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Work;
